import axios from "axios";
import { Toast } from "../../util/Toast";

import { GET_SELLER, SET_ADMIN, UNSET_ADMIN, UPDATE_PROFILE } from "./types";
import { key } from "../../util/Config";

export const login = (data) => (dispatch) => {
  axios
    .post(`agency/login?key=${key}`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "You have successfully logged in Ⴆσσɱҽɾ Lιʋҽ.");
        setTimeout(() => {
          window.location.href = "/host/dashboard";
        }, 100);
        dispatch({ type: SET_ADMIN, payload: res.data.token });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

export const getProfile = (hostId) => (dispatch) => {
  if (!hostId) return;
  axios
    .get(`host/profile?hostId=${hostId}&_=${Date.now()}`)
    .then((res) => {
      if (res.data.status) {
        const data = res.data?.data || {};
        const week = data.weekly?.hostThisWeek;
        const weekCoins = Number(week?.eligibleCoins ?? data.weekCoins ?? 0) || 0;
        const weekLevel = Number(week?.level ?? data.salaryLevel ?? 0) || 0;
        const weekSalary = Number(week?.salaryUsd ?? data.salaryDollar ?? 0) || 0;
        dispatch({
          type: GET_SELLER,
          payload: {
            ...data,
            // STRICT: current-week target only. Never User.rCoin / lifetime currentCoin.
            weekCoins,
            salaryLevel: weekLevel,
            salaryDollar: weekSalary,
            currentCoin: weekCoins,
            weekId: data.weekId || data.weekly?.weekId || null,
            withdrawableUsd:
              data.withdrawableUsd != null
                ? Number(data.withdrawableUsd)
                : Math.trunc(Number(data.withdrawableUsdCents || 0)) / 100,
          },
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
    });
};



export const changePassword = (data) => (dispatch) => {
  axios
    .put("admin", data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Password changed successfully.");
        setTimeout(() => {
          dispatch({ type: UNSET_ADMIN });
          window.location.href = "/host";
        }, [3000]);
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const updateProfile = (agency_id, data) => (dispatch) => {
  axios
    .patch(`agency/profile/${agency_id}`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Profile updated successfully.");
        dispatch({ type: UPDATE_PROFILE, payload: res.data?.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
